import { createFileRoute } from "@tanstack/react-router";
import { HeadlessRenderTestPage } from "test/util/HeadlessRenderTestPage";
import { addStrokeTestTHREEGeometry, STROKE_TEST_CAMERA_SETTINGS, STROKE_TEST_KEYS } from "test/util/strokeTestUtil";
import withAuthentication from "../../components/withAuthentication";

function StrokeTestPage() {
  const options = {
    cameraSettings: STROKE_TEST_CAMERA_SETTINGS,
    useMSAA: false,
  };

  return (
    <HeadlessRenderTestPage
      testName="Stroke render"
      options={options}
      testKeys={STROKE_TEST_KEYS}
      addGeometry={addStrokeTestTHREEGeometry}
    />
  );
}

export const Route = createFileRoute("/debug/stroke-test")({
  component: withAuthentication(StrokeTestPage, { superAdmin: true }),
});
